import {Injectable} from '@angular/core';
import {EdiFileBaseService} from "@app/processing/services/edi-file-base.service";
import {GlobalService} from "@app/_services/global.service";
import {Observable} from "rxjs";
import {
    BackoutRequest,
    BackoutResponse,
    EdiFileSummaryFilter,
    EdiFileSummaryResponse,
    EdiInvalidIdentifier,
    ReprocessingFile,
    ReprocessingResponse
} from "@app/_models/api";
import {ApiService} from "@app/_services/api.service";

@Injectable({
    providedIn: 'root'
})
export class EdiFile867Service extends EdiFileBaseService {
    override fileType: string = '867';
    constructor(globalService: GlobalService, apiService: ApiService) {
        super(globalService, apiService);
    }

    getFiles(filter: EdiFileSummaryFilter): Observable<EdiFileSummaryResponse[]> {
        return this.apiService.getEdi867FileSummary(filter);
    }

    getInvalidIdentifiers(customerId: string): Observable<EdiInvalidIdentifier[]> {
        return this.apiService.getEdi867InvalidIdentifiers(customerId);
    }

    submitReprocessingRequest(files: ReprocessingFile[]): Observable<ReprocessingResponse> {
        return this.apiService.reprocess867Files(files);
    }

    submitBackoutRequest(files: BackoutRequest[]): Observable<BackoutResponse> {
        return this.apiService.backout867Files(files);
    }
}
